import { SubpropertyService } from '@modules/subproperty/subproperty-service';
import Errors from '@shared/error/errors';
import { routerAsync } from '@/app-module';
import Message from '@shared/message/message';
import { i18n } from '@shared/i18n';
import ManageModel from '@shared/manage/manage-model';
import { update, get } from 'lodash';

export default {
  namespaced: true,

  state: {
    findLoading: false,
    saveLoading: false,
    record: null,
  },

  getters: {
    record: (state) => state.record,
    findLoading: (state) => !!state.findLoading,
    saveLoading: (state) => !!state.saveLoading,
  },

  mutations: {
    RESET(state) {
      state.findLoading = false;
      state.saveLoading = false;
      state.record = null;
    },

    NEW_SUCCESS(state, { fixedFee = 0, variableFee = 1.1 } = {}) {
      if (!state.record) state.record = {};
      state.record.owqloFeeFixed = fixedFee;
      state.record.owqloFeePercentage = variableFee;
    },

    FIND_STARTED(state) {
      state.record = null;
      state.findLoading = true;
    },

    FIND_SUCCESS(state, payload) {
      state.record = payload;
      state.findLoading = false;
    },

    FIND_ERROR(state) {
      state.record = null;
      state.findLoading = false;
    },

    CREATE_STARTED(state) {
      state.saveLoading = true;
    },

    CREATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    CREATE_ERROR(state) {
      state.saveLoading = false;
    },

    UPDATE_STARTED(state) {
      state.saveLoading = true;
    },

    UPDATE_SUCCESS(state) {
      state.saveLoading = false;
    },

    UPDATE_ERROR(state) {
      state.saveLoading = false;
    },
  },

  actions: {
    doNew({ commit }) {
      commit('RESET');
      commit('NEW_SUCCESS');
    },

    async doFind({ commit, rootGetters }, id) {
      try {
        commit('FIND_STARTED');
       const currentManage = rootGetters['auth/manage/currentManage'];
        const manageInput = new ManageModel(currentManage).getManageModel()
        const record = await SubpropertyService.find(id,manageInput);

        const emails = get(record, 'managers', []).map(({email}) => email);
        update(record, 'emails', () => emails ) 

        commit('FIND_SUCCESS', record);
      } catch (error) {
        Errors.handle(error);
        commit('FIND_ERROR');
        routerAsync().push('/subproperty/list');
      }
    },

    async doCreate({ commit, rootGetters }, values) {
      try {
        const currentManage = rootGetters['auth/manage/currentManage']; 
        commit('CREATE_STARTED');
        const subpropertyToSave = {
          ...values,
          propertyId : currentManage.property.id,
        }
        const manageInput = new ManageModel(currentManage).getManageModel()
        await SubpropertyService.create(subpropertyToSave, manageInput);
        commit('CREATE_SUCCESS');
        Message.success(i18n('entities.subproperty.create.success'));
        routerAsync().push('/subproperty/list');
      } catch (error) {
        Errors.handle(error);
        commit('CREATE_ERROR');
      }
    },

    async doUpdate({ commit, rootGetters }, { id, values }) {
      try {
        const currentManage = rootGetters['auth/manage/currentManage']; 
        commit('UPDATE_STARTED');
        const subpropertyToSave = {
          ...values
        }

        const manageInput = new ManageModel(currentManage).getManageModel()
        await SubpropertyService.update(id, subpropertyToSave, manageInput);

        commit('UPDATE_SUCCESS');
        Message.success(i18n('entities.subproperty.update.success'));
        routerAsync().push('/subproperty/list');
      } catch (error) {
        Errors.handle(error);
        commit('UPDATE_ERROR');
      }
    },
  },
};
